import { Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-item-load',
  templateUrl: './item-load.component.html',
  styleUrls: ['./item-load.component.scss']
})
export class ItemLoadComponent {
  @Input() loading: boolean = false;
  @Input() size : number = 20;

}
